import {
    LOADED_LESSONS,
    LOADED_LESSONS_TOTAL,
    LOADED_LESSONS_PAGES,
    LOADED_LESSONS_CURRENT,
    LOADED_LESSONS_LIMIT,
    SET_LESSON,
    LOADED_SCHEDULES,
    LOADED_SCHEDULES_TOTAL,
    LOADED_SCHEDULES_PAGES,
    LOADED_SCHEDULES_LIMIT,
    LOADED_SCHEDULES_CURRENT,
    LESSON_CODES_ADDED_TO_SELECTION,
    LESSON_CODES_REMOVED_FROM_SELECTION,
    LOADED_SCHEDULE,
    SET_TEACHER_FACILITATION_MOBILE_SHOW_STREAMS,
    SET_TEACHER_FACILITATION_QUESTION_FULLSCREEN,
    SET_TEACHER_FACILITATION_SELECTED_CARD_INDEX,
    SET_TEACHER_FACILITATION_SELECTED_STREAM_ID,
    SET_TEACHER_FACILITATION_SHOW_STUDENTS,
    SET_TEACHER_FACILITATION_SORT_BY
} from "../actions/lesson_actions";

const searchParams = new URLSearchParams(location.search);

const lessons = (payload = [], action) => {
    switch (action.type) {
        case LOADED_LESSONS:
            return action.payload;
        default:
            return payload;
    }
};
const lessons_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_LESSONS_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const lessons_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_LESSONS_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const lessons_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_LESSONS_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const lessons_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_LESSONS_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};

const lesson = (payload = {}, action) => {
    switch (action.type) {
        case SET_LESSON:
            return action.payload;
        default:
            return payload;
    }
};

const schedules = (payload = [], action) => {
    switch (action.type) {
        case LOADED_SCHEDULES:
            return action.payload;
        default:
            return payload;
    }
};
const schedules_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_SCHEDULES_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const schedules_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_SCHEDULES_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const schedules_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_SCHEDULES_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const schedules_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_SCHEDULES_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};

const lesson_scoring_schedule = (payload = null, action) => {
    switch (action.type) {
        case LOADED_SCHEDULE:
            return action.payload;
        default:
            return payload;
    }
};

const selected_lesson_codes = (state = [], action) => {
    switch (true) {
        case action.type === LESSON_CODES_ADDED_TO_SELECTION && Array.isArray(action.payload):
            state = JSON.parse(JSON.stringify(action.payload));
            break;
        case action.type === LESSON_CODES_REMOVED_FROM_SELECTION && Array.isArray(state):
            state = []
            break;
        default:
            return state;
    }

    return state;
};

const teacher_facilitation_show_student = (payload = true, action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_SHOW_STUDENTS:
            return action.payload;
        default:
            return payload;
    }
};
const teacher_facilitation_sort_by = (payload = 'name', action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_SORT_BY:
            return action.payload;
        default:
            return payload;
    }
};
const teacher_facilitation_selected_stream_id = (payload = null, action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_SELECTED_STREAM_ID:
            return action.payload;
        default:
            return payload;
    }
};
const teacher_facilitation_selected_card_index = (payload = 0, action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_SELECTED_CARD_INDEX:
            return action.payload;
        default:
            return payload;
    }
};
const teacher_facilitation_question_fullscreen = (payload = false, action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_QUESTION_FULLSCREEN:
            return action.payload;
        default:
            return payload;
    }
};
const teacher_facilitation_mobile_show_streams = (payload = false, action) => {
    switch (action.type) {
        case SET_TEACHER_FACILITATION_MOBILE_SHOW_STREAMS:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    lessons,
    lessons_current,
    lessons_total,
    lessons_pages,
    lessons_limit,
    lesson,
    schedules,
    schedules_current,
    schedules_total,
    schedules_pages,
    schedules_limit,
    selected_lesson_codes,
    lesson_scoring_schedule,
    teacher_facilitation_show_student,
    teacher_facilitation_sort_by,
    teacher_facilitation_selected_stream_id,
    teacher_facilitation_selected_card_index,
    teacher_facilitation_question_fullscreen,
    teacher_facilitation_mobile_show_streams
}
